module.exports = __webpack_public_path__ + "aba4b415095d265d909e4f26ce33b18f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-city-s.png
// module id = 1877
// module chunks = 0